import { VideoTexture, SRGBColorSpace } from "three"


export let videoTvTexture
export let videoTv 

const createVideoTexture = () =>{
    videoTv = document.createElement('video')
    videoTv.src = '/textures/videoTexture/guacamayoBaby.mp4'
    videoTv.loop = true
    videoTv.playsInline = true

    videoTvTexture = new VideoTexture(videoTv)
    videoTvTexture.colorSpace = SRGBColorSpace

}

createVideoTexture()
